import { useEffect } from "react";
import { closeIcon } from "./svgs";
import { coverageNoteLabel } from "../cards/visitflow";

/* The day's "The following are covered for this patient: ..." note(s), behind
   the card's "i" next to the coverage chips. Shown as written: the note and the
   chips come from different sources and can disagree, and this is where the
   desk reads the note itself. `notes` arrive newest first. Each note says
   when it was saved and by whom ("Saved Oct 19, 3:12 PM by asmith", clinic
   time) when that was recorded; older notes show their date only. */
const CoverageNoteModal = ({ open, onClose, notes = [] }) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/30"
        onClick={onClose}
        aria-hidden="true"
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Coverage note"
        className="relative z-10 w-[560px] max-w-[92vw] max-h-[80vh] flex flex-col rounded-xl bg-white shadow-xl text-left"
      >
        <div className="flex items-center justify-between border-b px-6 py-3">
          <span className="text-[18px] font-semibold text-[#1D2951] font-font1">
            Coverage note
          </span>
          <button
            type="button"
            onClick={onClose}
            className="h-4 w-4 focus:outline-none focus:ring-0 focus:ring-offset-0 focus-visible:outline-none"
            aria-label="Close"
          >
            {closeIcon}
          </button>
        </div>
        <div className="px-6 py-4 overflow-y-auto flex flex-col gap-4">
          {notes.map((note, idx) => {
            const when = coverageNoteLabel(note);
            const extra = String(note?.notes || "").trim();
            const text = String(note?.ordername || "").trim();
            return (
              <div key={note?.id ?? idx} className="border-l-2 border-[#1D2951] pl-3">
                {when && (
                  <div className="text-[11px] font-inter text-[#6B7280] mb-1">
                    {when}
                  </div>
                )}
                <p className="text-[13px] font-inter text-[#1D2951] whitespace-pre-wrap break-words">
                  {text}
                </p>
                {extra && extra !== text && (
                  <p className="mt-1 text-[12px] font-inter text-[#4B5563] whitespace-pre-wrap break-words">
                    {extra}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CoverageNoteModal;
